import { render, staticRenderFns } from "./BaseSwitchTheme.vue?vue&type=template&id=11d8c7ab&scoped=true&"
import script from "./BaseSwitchTheme.vue?vue&type=script&lang=js&"
export * from "./BaseSwitchTheme.vue?vue&type=script&lang=js&"
import style0 from "./BaseSwitchTheme.vue?vue&type=style&index=0&id=11d8c7ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d8c7ab",
  null
  
)

export default component.exports